<template>
  <div class="help-list">
    <mt-header fixed :title="titleText" class="title1">
      <mt-button slot="left" icon="back" @click="backClickHandler">返回</mt-button>
    </mt-header>
    <div>
      <div class="list-content">
        <mt-cell icon="search" title="收不到验证码怎么办？" :to="{ path: '/helpdetail', query: { id: '9' } }" is-link></mt-cell>
        <mt-cell title="客服电话" value="010-962909"></mt-cell>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'HelpListExamine',
  props: ['titleText'],
  data() {
    return {};
  },
  methods: {
    backClickHandler() {
      window.location.href = 'protocol://android';
    },
  },
};
</script>
